
import React, { useEffect, useRef, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import AkkhorLayout from "../layout/akkhor";
import { URL_LIST_ALL } from "../configs/api";
import { useSelector } from "react-redux";
import Axios from "axios";
import men_teacher from "../assets/img/thumbnail-icon.png"
import { useParams } from "react-router-dom";

export default function DanhSachBaiHoc() {
    const { id } = useParams();
    const { user } = useSelector((state) => state.auth);
    const [listData, setListData] = useState([])
    const [detail, setDetail] = useState(null)


    useEffect(
        function () {
            if (id > 0) {
                Axios.get(URL_LIST_ALL + "learninghub_khoahoc/" + id, user.config)
                    .then(async (res) => {
                        if (res.data.status === "success") {
                            setDetail(res.data.data);
                        } else console.log(res.data.message);
                    })
                    .catch((err) => console.log(err));
                Axios.get(URL_LIST_ALL + "learninghub_baigiang?type_id=" + id, user.config)
                    .then(async (res) => {
                        if (res.data.status === "success") {
                            setListData(res.data.data);
                        } else console.log(res.data.message);
                    })
                    .catch((err) => console.log(err));

            }
        }, [user, id]
    );

    const linkify = (html) =>
        html.replace(
            /(?<!src="|href="|">)(https?:\/\/[^\s<]+)/g,
            '<a href="$1" class="text-danger" target="_blank" rel="noopener noreferrer">$1</a>'
        );

    return (<AkkhorLayout idrole="dashboard">
        <div className="breadcrumbs-area">
            <ul>
                <li>
                    <Link to="/">Trang chủ</Link>
                </li>
                <li>
                    Bài học
                </li>
            </ul>
        </div>

        <div className="w-100 list-profile">
            <div className="row">
                <h3 className="col-12 text-center mb-3">Danh Sách Các Bài Giảng: {detail && detail.title}</h3>
                <div className="row">
                    {listData && listData.map((item) => {
                        return (<div className="col-12 col-sm-3 profile-item" key={item.id}>
                            <div className="wrapper border shadow" onClick={() => {
                                window.location.href = "/bai-hoc-chi-tiet/" + item.id
                            }}>
                                <div className="w-100 d-flex justify-content-center p-3">
                                    <div className="avatar-group">
                                        <img src={item.thumbnail ? item.thumbnail : men_teacher} alt="" className="" />
                                    </div>
                                </div>
                                <div className="w-100 p-3 pt-0">
                                    <h5 className="w-100 text-center title">{item.title}</h5>
                                    <div className="w-100 text-center description mt-2">
                                        <div className="w-100 mt-2 post-content" dangerouslySetInnerHTML={{ __html: linkify(item.description) }} />
                                    </div>
                                </div>
                            </div>
                        </div>)
                    })}

                </div>
            </div>
        </div>

    </AkkhorLayout>);
}
